import { PercentageFieldAdapter } from '../../components/experience/forms/PercentageFieldAdapter';
import { registerFieldAdapter } from './field-adapters';

registerFieldAdapter({
  fieldType: 'percentage',
  component: PercentageFieldAdapter,
});
